import m from 'moment';
import type { Observable } from 'rxjs';
import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { momentMapper } from '@bp/shared/models/metadata';

import { MomentBasePipe } from './moment-base.pipe';

@Pipe({
	name: 'momentToNow',
})
export class MomentToNowPipe extends MomentBasePipe implements PipeTransform {
	transform(momentInput: m.MomentInput, withoutSuffix?: 'withoutSuffix'): Observable<string> {
		return this._momentTimezoneService.timezone$.pipe(
			switchMap(() => this._momentToNowUpdatedEach30Seconds(momentInput, withoutSuffix)),
		);
	}

	private _momentToNowUpdatedEach30Seconds(
		momentInput: m.MomentInput,
		withoutSuffix: string | undefined,
	): Observable<string> {
		const toMoment = momentMapper(momentInput);

		return timer(0, 1000 * 30)
			.pipe(
				map(() => m().to(toMoment, !!withoutSuffix)),
			);
	}
}
